"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _colors = require("HubStyleTokens/colors");

var _theme = require("HubStyleTokens/theme");

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Big = _interopRequireDefault(require("UIComponents/elements/Big"));

var _UIBreakString = _interopRequireDefault(require("UIComponents/text/UIBreakString"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIIconHolder = _interopRequireDefault(require("UIComponents/icon/UIIconHolder"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UITable = _interopRequireDefault(require("UIComponents/table/UITable"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var Sync = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/dataSyncs/Sync"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    &,\n    thead th {\n      text-align: center;\n    }\n\n    tbody tr:nth-child(even) {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var I18N_PATH = 'appMarketplace.detail.dataPermissions.dataSyncs';
var SYNC_DATA_ICON_SIZE = 32;
var SYNC_DIRECTION_ICON_SIZE = 20;
var StyledTable = (0, _styledComponents.default)(_UITable.default).withConfig({
  displayName: "DataSyncs__StyledTable",
  componentId: "ajg07w-0"
})(_templateObject(), _theme.TABLE_ROW_HOVER_BACKGROUND_COLOR);

var SyncDirectionIcon = function SyncDirectionIcon(_ref) {
  var sync = _ref.sync;

  switch (sync) {
    case Sync.INBOUND:
      return _react.default.createElement(_UIIcon.default, {
        name: "previous",
        size: SYNC_DIRECTION_ICON_SIZE
      });

    case Sync.OUTBOUND:
      return _react.default.createElement(_UIIcon.default, {
        name: "next",
        size: SYNC_DIRECTION_ICON_SIZE
      });

    case Sync.BOTH:
      return _react.default.createElement(_UIFlex.default, {
        justify: "center",
        wrap: "nowrap"
      }, _react.default.createElement(_UIIcon.default, {
        name: "previous",
        size: SYNC_DIRECTION_ICON_SIZE
      }), _react.default.createElement(_UIIcon.default, {
        name: "next",
        size: SYNC_DIRECTION_ICON_SIZE
      }));

    default:
      return null;
  }
};

var DataSyncs = function DataSyncs(_ref2) {
  var dataSyncInfo = _ref2.dataSyncInfo,
      dataSyncs = _ref2.dataSyncs,
      iconUrl = _ref2.iconUrl,
      name = _ref2.name,
      onTrackInteraction = _ref2.onTrackInteraction;
  var renderedDataSyncRows = dataSyncs.map(function (dataSync, index) {
    var description = dataSync.get('description');
    var renderedDescription = description ? _react.default.createElement(_UIHelpIcon.default, {
      className: "m-right-2",
      title: description,
      tooltipProps: {
        onOpenChange: function onOpenChange(_ref3) {
          var open = _ref3.target.value;

          if (open) {
            onTrackInteraction('hover data sync description help icon', 'data and permissions');
          }
        }
      }
    }) : null;
    return _react.default.createElement("tr", {
      key: "data-sync-" + index
    }, _react.default.createElement("td", null, _react.default.createElement(_UIFlex.default, {
      align: "center",
      justify: "center"
    }, renderedDescription, _react.default.createElement(_Big.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: (0, _i18n.getDataSyncsDataI18nKey)(dataSync.get('data'))
    })))), _react.default.createElement("td", null, _react.default.createElement(SyncDirectionIcon, {
      sync: dataSync.get('sync')
    })), _react.default.createElement("td", null, _react.default.createElement(_Big.default, null, dataSync.get('target'))));
  });
  var renderedDataSyncInfo = dataSyncInfo ? _react.default.createElement(_react.Fragment, null, _react.default.createElement("b", null, _react.default.createElement(_FormattedMessage.default, {
    message: I18N_PATH + ".moreInfoText"
  })), _react.default.createElement("p", null, _react.default.createElement(_UIBreakString.default, null, dataSyncInfo))) : null;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(StyledTable, {
    hover: false
  }, _react.default.createElement("colgroup", null, _react.default.createElement("col", {
    style: {
      width: '40%'
    }
  }), _react.default.createElement("col", null), _react.default.createElement("col", {
    style: {
      width: '40%'
    }
  })), _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", null, _react.default.createElement(_UITooltip.default, {
    title: (0, _unescapedText.default)(I18N_PATH + ".hubspot")
  }, _react.default.createElement(_UIIconHolder.default, {
    color: _colors.LORAX,
    name: "sprocket",
    padding: 0.25,
    size: SYNC_DATA_ICON_SIZE
  }))), _react.default.createElement("th", null, _react.default.createElement(_FormattedMessage.default, {
    message: I18N_PATH + ".dataFlow"
  })), _react.default.createElement("th", null, _react.default.createElement(_UITooltip.default, {
    title: name
  }, _react.default.createElement(_UIImage.default, {
    responsive: false,
    src: iconUrl,
    width: SYNC_DATA_ICON_SIZE
  }))))), _react.default.createElement("tbody", null, renderedDataSyncRows)), renderedDataSyncInfo);
};

DataSyncs.propTypes = {
  dataSyncInfo: _propTypes.default.string,
  dataSyncs: _reactImmutableProptypes.default.listOf(CustomPropTypes.dataSync).isRequired,
  iconUrl: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  onTrackInteraction: _propTypes.default.func.isRequired
};
var _default = DataSyncs;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/dataSyncs/DataSyncs.js
// module id = 845
// module chunks = 209 210 211 212